import React from "react"

export const combineStyle = (...args: React.CSSProperties[]) => args.reduce((collection, styles) => ({ ...collection, ...styles }), {})
